import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, color = "#E7212B" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_45_42351)">
        <path
          d="M5.83398 5.83337H5.00065C4.55862 5.83337 4.1347 6.00897 3.82214 6.32153C3.50958 6.63409 3.33398 7.05801 3.33398 7.50004V15C3.33398 15.4421 3.50958 15.866 3.82214 16.1786C4.1347 16.4911 4.55862 16.6667 5.00065 16.6667H12.5007C12.9427 16.6667 13.3666 16.4911 13.6792 16.1786C13.9917 15.866 14.1673 15.4421 14.1673 15V14.1667"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9875 5.48747C17.3157 5.15926 17.5001 4.71412 17.5001 4.24997C17.5001 3.78581 17.3157 3.34067 16.9875 3.01247C16.6593 2.68426 16.2142 2.49988 15.75 2.49988C15.2858 2.49988 14.8407 2.68426 14.5125 3.01247L7.5 9.99997V12.5H10L16.9875 5.48747Z"
          stroke={color}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.334 4.16663L15.834 6.66663"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_45_42351">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgComponent;
